export { default } from './ChangeOfReferralStatusForm';
